import React, { FC, ReactNode } from 'react'
import Auth, { IToken } from '@getgo/auth-client'
import { IAuthOptions } from '@getgo/auth-client/lib/auth'
import useLocalStorage, { writeStorage } from '@rehooks/local-storage'

import config from 'config'

const options: IAuthOptions = {
  client_id: config.CLIENT_ID,
  url: config.AUTH_SERVICE_URL,
  redirect_url: `${window.location.origin}/authenticate/callback`,
  enableTokenRefresh: true,
}

export const auth = new Auth(options)

interface GetGoAuthProviderProps {
  children?: ReactNode
}

const GetGoAuthProvider: FC<GetGoAuthProviderProps> = ({ children }) => {
  const tokenName = config.AUTH_TOKEN_KEY
  const tokenFromCb = auth.init()
  const [token] = useLocalStorage<IToken | any>(tokenName, localStorage.getItem(tokenName))

  if (tokenFromCb) {
    window[tokenName] = tokenFromCb
    writeStorage(tokenName, tokenFromCb)

    if (tokenFromCb.state) {
      window.location.assign(new URL(tokenFromCb.state.inflightRequest, window.location.toString()).pathname)
    }

    return null
  } else {
    if (token && token !== 'null') {
      window[tokenName] = token
    } else {
      auth.login({
        state: { inflightRequest: window.location.pathname },
      })

      return null
    }
  }

  return <>{window[tokenName] ? children : 'Logging you in...'}</>
}

export default GetGoAuthProvider
